export default __webpack_public_path__ + "img/1ab7914c72667a300f621dd2253cf901.png";